import { Link } from 'react-router';

import { cx } from '../lib/cx.ts';
import { PlusIcon } from './icons.tsx';

/**
 * The floating log action. Bottom right, clear of the tab bar and the iOS home
 * indicator, within thumb reach on a phone held one-handed. This is the single
 * most important control in the app — see the PRD's ten-second target.
 */
export function LogAction() {
  return (
    <Link
      to="/log"
      className={cx(
        'fixed right-4 z-40 flex items-center gap-2 rounded-full',
        'bg-accent px-5 text-accent-contrast shadow-lg',
        'min-h-fab font-strong',
        'transition-colors duration-(--ui-duration-fast) hover:bg-accent-hover',
        'bottom-[calc(var(--ui-tabbar-height)+env(safe-area-inset-bottom)+1rem)]',
        'rail:bottom-6',
      )}
    >
      <PlusIcon className="size-5" />
      Log
    </Link>
  );
}
